module.exports = __webpack_public_path__ + "img/39.8e3c5e15.jpg";